import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import entityComposition from '../common/classes/entityComposition';
import CabinetCsvExportColumnModal from './cabinetCsvExportColumnModal';
import ErrorDetailsToggle from './errorDetailsToggle';
const ModalNotification = ({
  list
}) => {
  var _content$selectionRef, _content$selectionRef2, _content$selectionRef3, _content$selectionRef4;
  const [, setExportButtonVersion] = useState(0);
  const onExportReadyChange = useCallback(() => setExportButtonVersion(version => version + 1), []);
  if (list.length === 0) {
    return null;
  }
  const [{
    content
  }] = list;
  const isCabinetCsvExport = content.modalKind === 'cabinetCsvExportColumns';
  const isExportReady = (_content$selectionRef = (_content$selectionRef2 = content.selectionRef) === null || _content$selectionRef2 === void 0 ? void 0 : _content$selectionRef2.isExportReady) !== null && _content$selectionRef !== void 0 ? _content$selectionRef : false;
  const isLoadingColumns = (_content$selectionRef3 = (_content$selectionRef4 = content.selectionRef) === null || _content$selectionRef4 === void 0 ? void 0 : _content$selectionRef4.isLoadingColumns) !== null && _content$selectionRef3 !== void 0 ? _content$selectionRef3 : false;
  const {
    headerMessage,
    message,
    hint,
    technicalDetail,
    reference,
    errorCode
  } = content;
  const buttons = ['left', 'middle', 'right'].map(direction => {
    let label = content[`${direction}ButtonLabel`];
    let disabled = content[`${direction}ButtonDisabled`];
    if (direction === 'right' && isCabinetCsvExport) {
      if (isExportReady) {
        label = 'Export';
        disabled = false;
      } else if (isLoadingColumns) {
        label = 'Loading columns...';
        disabled = true;
      } else {
        label = 'Export';
        disabled = true;
      }
    }
    const action = content[`${direction}ButtonAction`];
    const color = content[`${direction}ButtonColor`];
    if (!label) return undefined;
    return /*#__PURE__*/React.createElement(Button, {
      key: `btn-${label}`,
      color: color,
      disabled: disabled,
      onClick: () => action()
    }, label);
  });
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: true,
    style: {
      maxWidth: '800px'
    }
  }, /*#__PURE__*/React.createElement(ModalHeader, null, headerMessage || content.headerMessage), /*#__PURE__*/React.createElement(ModalBody, {
    className: "t-error-details-host",
    style: {
      whiteSpace: 'pre-line',
      wordBreak: 'break-word'
    }
  }, isCabinetCsvExport ? /*#__PURE__*/React.createElement(CabinetCsvExportColumnModal, {
    formTypes: content.formTypes,
    totalCount: content.totalCount,
    selectionRef: content.selectionRef,
    loadColumnOptions: content.loadColumnOptions,
    onExportReadyChange: onExportReadyChange
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, message || content.message, /*#__PURE__*/React.createElement(ErrorDetailsToggle, {
    hint: hint || content.hint || '',
    technicalDetail: technicalDetail || content.technicalDetail || '',
    reference: reference || content.reference || '',
    errorCode: errorCode || content.errorCode || ''
  }))), /*#__PURE__*/React.createElement(ModalFooter, null, buttons));
};
ModalNotification.propTypes = {
  notificationActions: PropTypes.shape({
    dismiss: PropTypes.func
  }).isRequired,
  list: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export { ModalNotification as TestModalNotification };
export default entityComposition(ModalNotification, [], {}, ['notification']);